import styled from 'styled-components';
import { FormControlLabel, Switch } from '@mui/material';
import { withStyles } from '@mui/styles';
import { red, pink } from '@mui/material/colors';
import { Colors, Animations, Styling } from '../../../constants';
import { VaultButton } from '../../Shared';

interface ISearchInputProps {
  $isQuerying: boolean;
}

// NOTE: search result page style patch, to be iterated
export const Container = styled.div`
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;

  font-size: 14px;
`;

export const SearchResultsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background-color: ${Colors.WHITE_100};

  position: relative;
`;

export const QueryControlsRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 0;
  padding: ${Styling.DEFAULT_SPACING}px;
  background-color: ${Colors.BLACK_100};
`;

export const InnerQueryControlsRow = styled.div`
  width: 100%;
  display: flex;
  align-items: stretch;
`;

export const SearchInput = styled.input<ISearchInputProps>`
  flex-grow: 1;
  padding: ${Styling.DEFAULT_SPACING_HALVED}px;
  border-radius: ${Styling.DEFAULT_BORDER_RADIUS}px;
  background-color: ${Colors.WHITE_25};
  border: none;
  color: ${Colors.WHITE_80};
  font-size: 14px;

  transition: border ${Animations.DEFAULT_TRANSITION};

  ::placeholder {
    color: ${Colors.WHITE_50};
  }

  cursor: ${(props: ISearchInputProps) => (props.$isQuerying ? 'not-allowed' : 'initial')};
`;

export const SearchButton = styled(VaultButton)`
  margin-left: ${Styling.DEFAULT_SPACING_HALVED}px;
  width: 122px;
`;

export const StyledControl = styled(FormControlLabel)`
  margin-left: ${Styling.DEFAULT_SPACING_HALVED}px !important;
  margin-right: ${Styling.DEFAULT_SPACING_HALVED}px !important;
  width: 130px !important;
  .MuiFormControlLabel-label {
    font-size: 0.75rem;
    color:white;
  }
`;

export const RedSwitch = withStyles({
  switchBase: {
    color: red[700],
    '&$checked': {
      color: red[700],
    },
    '& + $track': {
      backgroundColor: pink[400],
    },
  },
  checked: {},
  track: {},
})(Switch);
